export class Tarifvertrag {
  constructor({
    id,
    tarifvertragTyp,
    tarifgruppen,
  }: {
    id: string;
    tarifvertragTyp: TarifvertragTyp;
    tarifgruppen: Tarifgruppen[];
  }) {
    this.id = id;
    this.tarifvertragTyp = tarifvertragTyp;
    this.tarifgruppen = tarifgruppen;
  }

  id: string;
  tarifvertragTyp: TarifvertragTyp;
  tarifgruppen: Tarifgruppen[];
}

export class Tarifgruppen {
  constructor({
    id,
    gruppe,
    stundenlohn,
    gehalt,
    gueltigAb,
  }: {
    id: string;
    gruppe: number;
    stundenlohn: number;
    gehalt: number;
    gueltigAb: Date;
  }) {
    this.id = id;
    this.gruppe = gruppe;
    this.stundenlohn = stundenlohn;
    this.gehalt = gehalt;
    this.gueltigAb = gueltigAb;
  }
  id: string;
  gruppe: number;
  stundenlohn: number;
  gehalt: number;
  gueltigAb: Date;
}

export enum TarifvertragTyp {
  BAECKEREI_WOLF = 'BAECKEREI_WOLF',
  MANTEL_BACK_BY = 'MANTEL_BACK_BY',
  MANTEL_BACK_NRW = 'MANTEL_BACK_NRW',
  MANTEL_BACK_SH = 'MANTEL_BACK_SH',
  MANTEL_SYSGASTRO_BDS = 'MANTEL_SYSGASTRO_BDS',
}
